import { Buffer } from 'buffer';

// music-metadata (used for audio file validation) relies on Node's Buffer global,
// which Angular's esbuild-based builder no longer polyfills automatically.
(window as unknown as { Buffer: typeof Buffer }).Buffer = Buffer;
